/**
 * @internal
 */
const gaveWarnings = {};
const warnOnce = (id, ...message) => {
    var _a, _b;
    if (!gaveWarnings[id] &&
        typeof process === 'object' &&
        (((_a = process === null || process === void 0 ? void 0 : process.env) === null || _a === void 0 ? void 0 : _a.NODE_ENV) === 'development' || ((_b = process === null || process === void 0 ? void 0 : process.env) === null || _b === void 0 ? void 0 : _b.NODE_ENV) === 'test')) {
        console.warn(...message);
        gaveWarnings[id] = true;
    }
};
export default warnOnce;
